export const SlinkyDogZigzagSpin = (type) => {
    let datas;
    if (type === 'icon')
        datas = require.context('../../assets/images/attractions/manege-fixe/slinky-dog-zigzag-spin/icon', false);
    if (type === 'img')
        datas = require.context('../../assets/images/attractions/manege-fixe/slinky-dog-zigzag-spin/img', false);
    return datas.keys().map(image => datas(image));
}